<template>
  <v-form ref="form" autocomplete="off">
    <div class="d-flex align-center ga-4 mb-4">
      <h2 class="font-weight-bold">Dato - {{ this.datoId }} - {{ this.descdato }}</h2>
      <v-divider class="mx-4" inset vertical></v-divider>
    </div>
    <!-- ================= FORMULARIO ================= -->
    <v-row>
      <!-- Operación 1  -->
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="editedItem.TipoUno"
          :items="ArrayTipoDatoCalculado"
          :item-title="
            (ArrayTipoDatoCalculado) =>
              ArrayTipoDatoCalculado.Valor + '-' + ArrayTipoDatoCalculado.Descripcion
          "
          @update:modelValue="ChangeTipoUno()"
          item-value="Valor"
          color="primary"
          label="Operación 1:"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Dato 1  -->
      <v-col
        v-if="
          editedItem.TipoUno == TipoDatoCalculado.Datos ||
          editedItem.TipoUno == TipoDatoCalculado.DatosAutomaticos ||
          editedItem.TipoUno == TipoDatoCalculado.Secuencia
        "
        cols="12"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.DatoUno"
          :items="ArrayDatos"
          :item-title="(ArrayDatos) => ArrayDatos.Codigo + ' - ' + ArrayDatos.Label"
          item-value="Codigo"
          color="primary"
          label="Dato 1:"
          dense
          clearable
          :rules="
            editedItem.TipoUno == TipoDatoCalculado.Datos ||
            editedItem.TipoUno == TipoDatoCalculado.DatosAutomaticos ||
            editedItem.TipoUno == TipoDatoCalculado.Secuencia
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Valor 1 -->
      <v-col v-if="editedItem.TipoUno == TipoDatoCalculado.Valor" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.ValorUno"
          label="Valor 1:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="tel"
          hint="Digite Información"
          :rules="editedItem.TipoUno == TipoDatoCalculado.Valor ? [rules.required] : []"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Secuencia 1  -->
      <v-col
        v-if="editedItem.TipoUno == TipoDatoCalculado.SecuenciaResultado"
        cols="12"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.SecuenciaUno"
          :items="ArraySecuencia"
          :item-title="(ArraySecuencia) => ArraySecuencia.Secuencia"
          item-value="Secuencia"
          color="primary"
          label="Secuencia 1:"
          dense
          clearable
          :rules="
            editedItem.TipoUno == TipoDatoCalculado.SecuenciaResultado
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Constante 1  -->
      <v-col v-if="editedItem.TipoUno == TipoDatoCalculado.Constante" cols="12" md="6">
        <v-autocomplete
          v-model="editedItem.ConstanteUno"
          :items="ArrayNumeroConstante"
          :item-title="
            (ArrayNumeroConstante) =>
              ArrayNumeroConstante.Codigo + '-' + ArrayNumeroConstante.Descripcion
          "
          item-value="Codigo"
          color="primary"
          label="Constante 1:"
          dense
          clearable
          :rules="
            editedItem.TipoUno == TipoDatoCalculado.Constante ? [rules.required] : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Tipo de Operacion  -->
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="editedItem.Operador"
          :items="ArraySimboloOperacion"
          :item-title="
            (ArraySimboloOperacion) =>
              ArraySimboloOperacion.Valor + '-' + ArraySimboloOperacion.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Tipo de operación:"
          dense
          clearable
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Operación 2  -->
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="editedItem.TipoDos"
          :items="ArrayTipoDatoCalculado"
          :item-title="
            (ArrayTipoDatoCalculado) =>
              ArrayTipoDatoCalculado.Valor + ' - ' + ArrayTipoDatoCalculado.Descripcion
          "
          item-value="Valor"
          color="primary"
          label="Operación 2:"
          dense
          clearable
          @update:modelValue="ChangeTipoDos()"
          :rules="[rules.required]"
        >
        </v-autocomplete>
      </v-col>

      <!-- Dato 2  -->
      <v-col
        v-if="
          editedItem.TipoDos == TipoDatoCalculado.Datos ||
          editedItem.TipoDos == TipoDatoCalculado.DatosAutomaticos ||
          editedItem.TipoDos == TipoDatoCalculado.Secuencia
        "
        cols="12"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.DatoDos"
          :items="ArrayDatos"
          :item-title="(ArrayDatos) => ArrayDatos.Codigo + ' - ' + ArrayDatos.Label"
          item-value="Codigo"
          color="primary"
          label="Dato 2:"
          dense
          clearable
          :rules="
            editedItem.TipoDos == TipoDatoCalculado.Datos ||
            editedItem.TipoDos == TipoDatoCalculado.DatosAutomaticos ||
            editedItem.TipoDos == TipoDatoCalculado.Secuencia
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Valor 2 -->
      <v-col v-if="editedItem.TipoDos == TipoDatoCalculado.Valor" cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.ValorDos"
          label="Valor 2:"
          clearable
          dense
          maxlength="20"
          counter="20"
          type="tel"
          hint="Digite Información"
          :rules="editedItem.TipoDos == TipoDatoCalculado.Valor ? [rules.required] : []"
          v-on:keypress="isNumber()"
        >
        </v-text-field>
      </v-col>

      <!-- Secuencia 2  -->
      <v-col
        v-if="editedItem.TipoDos == TipoDatoCalculado.SecuenciaResultado"
        cols="12"
        md="6"
      >
        <v-autocomplete
          v-model="editedItem.SecuenciaDos"
          :items="ArraySecuencia"
          :item-title="(ArraySecuencia) => ArraySecuencia.Secuencia"
          item-value="Secuencia"
          color="primary"
          label="Secuencia 2:"
          dense
          clearable
          :rules="
            editedItem.TipoDos == TipoDatoCalculado.SecuenciaResultado
              ? [rules.required]
              : []
          "
        >
        </v-autocomplete>
      </v-col>

      <!-- Constante 2  -->
      <v-col v-if="editedItem.TipoDos == TipoDatoCalculado.Constante" cols="12" md="6">
        <v-autocomplete
          v-model="editedItem.ConstanteDos"
          :items="ArrayNumeroConstante"
          :item-title="
            (ArrayNumeroConstante) =>
              ArrayNumeroConstante.Codigo + '-' + ArrayNumeroConstante.Descripcion
          "
          item-value="Codigo"
          color="primary"
          label="Constante 2:"
          dense
          clearable
          :rules="
            editedItem.TipoDos == TipoDatoCalculado.Constante ? [rules.required] : []
          "
        >
        </v-autocomplete>
      </v-col>

      <v-col cols="12" md="2">
        <v-btn color="blue" @click="adicionarProceso"> Adicionar </v-btn>
      </v-col>
    </v-row>

    <div align="right" class="mb-6">
      <v-btn color="green" @click="ValidateCampos"> Guardar </v-btn>
    </div>

    <!-- ================= TABLA DRAG ================= -->

    <v-card>
      <v-card>
        <v-card-title> Secuencia Dato - Calculado</v-card-title>

        <v-table height="550px">
          <thead>
            <tr>
              <th style="width: 40px"></th>
              <th style="width: 80px">Acciones</th>
              <th style="width: 40px">Secuencia</th>
              <th>Operación 1</th>
              <th>Registro 1</th>
              <th>Operador</th>
              <th>Operación 2</th>
              <th>Registro 2</th>
            </tr>
          </thead>

          <draggable
            v-model="items"
            tag="tbody"
            item-key="Dato"
            handle=".drag-handle"
            animation="200"
            @end="guardarOrden"
          >
            <template #item="{ element }">
              <tr>
                <td class="drag-handle">☰</td>
                <td>
                  <v-icon color="red" @click="eliminarFila(element)">mdi-delete</v-icon>
                </td>
                <td>{{ element.Secuencia }}</td>
                <td>{{ element.TipoUno }}-{{ element.DescTipoUno }}</td>
                <td>
                  {{
                    element.TipoUno == TipoDatoCalculado.Datos ||
                    element.TipoUno == TipoDatoCalculado.Secuencia ||
                    element.TipoUno == TipoDatoCalculado.DatosAutomaticos
                      ? element.DatoUno + " - " + element.DescDatoUno
                      : element.TipoUno == TipoDatoCalculado.SecuenciaResultado
                      ? element.SecuenciaUno
                      : element.TipoUno == TipoDatoCalculado.Valor
                      ? element.ValorUno
                      : element.TipoUno == TipoDatoCalculado.Constante
                      ? element.ConstanteUno + " - " + element.DescConstanteUno
                      : ""
                  }}
                </td>
                <td>{{ element.Operador }} - {{ element.DescOperador }}</td>
                <td>{{ element.TipoDos }} - {{ element.DescTipoDos }}</td>
                <td>
                  {{
                    element.TipoDos == TipoDatoCalculado.Datos ||
                    element.TipoDos == TipoDatoCalculado.Secuencia ||
                    element.TipoDos == TipoDatoCalculado.DatosAutomaticos
                      ? element.DatoDos + " - " + element.DescDatoDos
                      : element.TipoDos == TipoDatoCalculado.SecuenciaResultado
                      ? element.SecuenciaDos
                      : element.TipoDos == TipoDatoCalculado.Valor
                      ? element.ValorDos
                      : element.TipoDos == TipoDatoCalculado.Constante
                      ? element.ConstanteDos + " - " + element.DescConstanteDos
                      : ""
                  }}
                </td>
              </tr>
            </template>
          </draggable>
        </v-table>
      </v-card>
    </v-card>
  </v-form>

  <!-- ================= PROGRESO ================= -->
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import {
  upsertDatosCalculados,
  getDatosCalculados,
  getSecuenciaDato,
} from "@/views/TCI/ProcesosP/DatoCalculado/DatoCalculadoService";
import { TipoDatoCalculado } from "@/views/TCI/ProcesosP/Constantes/ConstantesProcesosP";
import { TablaSeleccion } from "@/views/TCI/Seguridad/Constantes/ConstantesSeguridad";
import { getAllDatos } from "@/views/TCI/ProcesosP/Datos/DatosService";

export default {
  name: "dato-calculado",

  props: {
    info: {
      type: Object,
      default: null,
      Description: "Información de datos",
    },
  },

  components: {
    draggable,
  },

  data() {
    return {
      TipoDatoCalculado,
      TablaSeleccion,
      progreso: false,
      datoId: null,
      descdato: null,
      editedItem: {
        TipoUno: null,
        DatoUno: null,
        ValorUno: null,
        SecuenciaUno: null,
        ConstanteUno: null,
        Operador: null,
        TipoDos: null,
        DatoDos: null,
        ValorDos: null,
        SecuenciaDos: null,
        ConstanteDos: null,
      },

      modelfiltro: [
        {
          campo: "CodigoDato",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Dato:",
        },
      ],

      ArrayDatos: [],
      ArrayNumeroConstante: [],
      ArrayTipoDatoCalculado: [],
      ArraySimboloOperacion: [],
      ArraySecuencia: [],
      items: [],
      itemsEliminados: [],
      rules: {
        required: (v) => !!v || "Campo obligatorio",
      },
    };
  },

  methods: {
    async ValidateCampos() {
      if (this.items.length === 0) {
        this.$swal({
          icon: "warning",
          title: "No hay procesos para guardar",
        });
        return;
      }

      this.progreso = true;

      try {
        const dataGuardar = [
          ...this.items.map((item) => ({
            ...item,
            Eliminar: false,
          })),
          ...this.itemsEliminados,
        ];

        await upsertDatosCalculados(dataGuardar);

        this.$swal({
          icon: "success",
          title: "Guardado correctamente",
        });

        this.itemsEliminados = [];
        this.getSecuencia(this.datoId);
        this.getConsultData();
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.items = [];
      this.progreso = true;
      this.modelfiltro[0].contenido = this.datoId.toString();
      this.modelfiltro[0].filtro = "=";
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: true,
      };
      try {
        const result = await getDatosCalculados(data);

        // Guardamos el orden original
        this.items = result.map((item) => ({
          ...item,
          OrdenOriginal: item.Secuencia,
          EsNuevo: false, // bandera para nuevos
        }));
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
        this.dialogframe = false;
      }
    },

    guardarOrden() {
      this.reorganizarSecuencia();
      console.log("Nuevo orden:", this.items);
    },

    eliminarFila(item) {
      this.$swal({
        title: "¿Eliminar registro?",
        text: "Esta acción eliminará la fila seleccionada.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        // Si ya existe en BD, lo guardamos para eliminar en backend
        if (!item.EsNuevo) {
          this.itemsEliminados.push({
            CodigoDato: item.CodigoDato,
            Secuencia: item.Secuencia,
            OrdenOriginal: item.OrdenOriginal,
            Eliminar: true,
          });
        }

        // Se elimina de memoria
        this.items = this.items.filter((x) => x !== item);

        // Reorganizar secuencia
        this.reorganizarSecuencia();
      });
    },

    reorganizarSecuencia() {
      this.items.forEach((item, index) => {
        item.Secuencia = index + 1;
      });
    },

    reset() {
      this.ArrayNumeroConstante = this.$store.getters.MConstantes;

      var tabla = this.$store.getters.MTablaSeleccion;

      // Array tipo de dato calculado
      this.ArrayTipoDatoCalculado = tabla.filter(
        (item) =>
          item.Valor != null && item.TablaId == TablaSeleccion.TipoOperacionCalculado
      );

      // Array Operacion
      this.ArraySimboloOperacion = tabla.filter(
        (item) => item.Valor != null && item.TablaId == TablaSeleccion.SimboloOperacion
      );
    },

    async adicionarProceso() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
        return;
      }

      // Buscar el proceso completo en el array dato 1
      const datoSeleccionado1 = this.ArrayDatos.find(
        (p) => p.Codigo === this.editedItem.DatoUno
      );

      // Buscar el proceso completo en el array dato 2
      const datoSeleccionado2 = this.ArrayDatos.find(
        (p) => p.Codigo === this.editedItem.DatoDos
      );

      // Buscar el proceso completo en el array Constante Uno
      const constSeleccionado1 = this.ArrayNumeroConstante.find(
        (p) => p.Codigo === this.editedItem.ConstanteUno
      );

      // Buscar el proceso completo en el array Constante Dos
      const constSeleccionado2 = this.ArrayNumeroConstante.find(
        (p) => p.Codigo === this.editedItem.ConstanteDos
      );

      // Buscar el proceso completo en el array tipo de dato 1
      const tipoSeleccionado1 = this.ArrayTipoDatoCalculado.find(
        (p) => p.Valor == this.editedItem.TipoUno
      );

      // Buscar el proceso completo en el array tipo de dato 2
      const tipoSeleccionado2 = this.ArrayTipoDatoCalculado.find(
        (p) => p.Valor == this.editedItem.TipoDos
      );

      // Buscar el proceso completo en el array operador
      const operador = this.ArraySimboloOperacion.find(
        (p) => p.Valor == this.editedItem.Operador
      );

      var userperfil = this.$store.getters.userperfil;

      // Agregar a la tabla
      this.items.push({
        CodigoDato: this.datoId,
        Secuencia: this.items.length + 1,
        TipoUno: this.editedItem.TipoUno,
        DescTipoUno: tipoSeleccionado1 ? tipoSeleccionado1.Descripcion : "",
        DatoUno: this.editedItem.DatoUno,
        DescDatoUno: datoSeleccionado1 ? datoSeleccionado1.Descripcion : "",
        ValorUno: this.editedItem.ValorUno,
        SecuenciaUno: this.editedItem.SecuenciaUno,
        ConstanteUno: this.editedItem.ConstanteUno,
        DescConstanteUno: constSeleccionado1 ? constSeleccionado1.Descripcion : "",
        Operador: this.editedItem.Operador,
        DescOperador: operador ? operador.Descripcion : "",
        TipoDos: this.editedItem.TipoDos,
        DescTipoDos: tipoSeleccionado2 ? tipoSeleccionado2.Descripcion : "",
        DatoDos: this.editedItem.DatoDos,
        DescDatoDos: datoSeleccionado2 ? datoSeleccionado2.Descripcion : "",
        ValorDos: this.editedItem.ValorDos,
        SecuenciaDos: this.editedItem.SecuenciaDos,
        ConstanteDos: this.editedItem.ConstanteDos,
        DescConstanteDos: constSeleccionado2 ? constSeleccionado2.Descripcion : "",
        UsuarioCreacion: userperfil.userInfo.Usuario_ID,
        UsuarioActualizacion: userperfil.userInfo.Usuario_ID,
        OrdenOriginal: null, // no tiene orden original
        EsNuevo: true, // es nuevo
      });

      // Limpiar selección
      this.editedItem.TipoUno = null;
      this.editedItem.DatoUno = null;
      this.editedItem.ValorUno = null;
      this.editedItem.SecuenciaUno = null;
      this.editedItem.ConstanteUno = null;
      this.editedItem.Operador = null;
      this.editedItem.TipoDos = null;
      this.editedItem.DatoDos = null;
      this.editedItem.ValorDos = null;
      this.editedItem.SecuenciaDos = null;
      this.editedItem.ConstanteDos = null;
    },

    // Consulta Datos
    async getDatos() {
      this.ArrayDatos = [];
      const result = await getAllDatos();
      this.ArrayDatos = result;
    },

    // Consulta Secuencia
    async getSecuencia(dato) {
      this.ArraySecuencia = [];
      const result = await getSecuenciaDato(dato);
      this.ArraySecuencia = result;
    },

    // Change Tipo Uno
    ChangeTipoUno() {
      this.editedItem.DatoUno = null;
      this.editedItem.ValorUno = null;
      this.editedItem.SecuenciaUno = null;
      this.editedItem.ConstanteUno = null;
    },

    // Change Tipo Dps
    ChangeTipoDos() {
      this.editedItem.DatoDos = null;
      this.editedItem.ValorDos = null;
      this.editedItem.SecuenciaDos = null;
      this.editedItem.ConstanteDos = null;
    },
  },

  mounted() {
    if (this.info) {
      this.datoId = this.info.Codigo;
      this.descdato = this.info.Descripcion;
    }

    this.reset();
    this.getConsultData();
    this.getDatos();
    this.getSecuencia(this.datoId);
  },
};
</script>

<style>
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
</style>
